module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc14-ced75793e0d15e2fad67cb819800b511.jpg";